import { render } from "./collectionDetail.vue?vue&type=template&id=8749f8d4&scoped=true"
import script from "./collectionDetail.vue?vue&type=script&lang=js"
export * from "./collectionDetail.vue?vue&type=script&lang=js"

import "./collectionDetail.vue?vue&type=style&index=0&id=8749f8d4&lang=scss"
import "./collectionDetail.vue?vue&type=style&index=1&id=8749f8d4&scoped=true&lang=css"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8749f8d4"]])

export default __exports__